'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dKind$0024$0024anon$00243 from "./app.data.-App-Document-Kind$$anon$3.js";
import * as $j_app$002edata$002e$002dApp$002dDocument$002dKind$0024$0024anon$00244 from "./app.data.-App-Document-Kind$$anon$4.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentKind$namedEnum$() {
  this.ahv = null;
  this.azn = null;
  this.azo = false;
  $n_Lapp_data_AppDocumentKind$namedEnum$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_data_AppDocumentKind$namedEnum$ as $c_Lapp_data_AppDocumentKind$namedEnum$ };
$p = $c_Lapp_data_AppDocumentKind$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentKind$namedEnum$;
/** @constructor */
function $h_Lapp_data_AppDocumentKind$namedEnum$() {
}
export { $h_Lapp_data_AppDocumentKind$namedEnum$ as $h_Lapp_data_AppDocumentKind$namedEnum$ };
$h_Lapp_data_AppDocumentKind$namedEnum$.prototype = $p;
$p.IK = (function() {
  return this.ahv;
});
$p.VV = (function(x$0) {
  this.ahv = x$0;
});
$p.bwE = (function(a) {
  var x = $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind();
  if ((x === a)) {
    return "purchaseOrder";
  }
  var x$3 = $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind();
  if ((x$3 === a)) {
    return "invoice";
  }
  var x$5 = $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind();
  if ((x$5 === a)) {
    return "certificateOfOrigin";
  }
  var x$7 = $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind();
  if ((x$7 === a)) {
    return "creditNote";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$p.wy = (function() {
  if ((!this.azo)) {
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().fw($m_Lapp_data_AppDocumentKind$().bx9());
    this.azn = $x_1.E4($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().aO(this$2));
    this.azo = true;
  }
  return this.azn;
});
$p.yN = (function(a) {
  return this.bwE(a);
});
var $d_Lapp_data_AppDocumentKind$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentKind$namedEnum$, "app.data.AppDocumentKind$namedEnum$", ({
  Ca: 1,
  da: 1
}));
export { $d_Lapp_data_AppDocumentKind$namedEnum$ as $d_Lapp_data_AppDocumentKind$namedEnum$ };
var $n_Lapp_data_AppDocumentKind$namedEnum$;
function $m_Lapp_data_AppDocumentKind$namedEnum$() {
  if ((!$n_Lapp_data_AppDocumentKind$namedEnum$)) {
    $n_Lapp_data_AppDocumentKind$namedEnum$ = new $c_Lapp_data_AppDocumentKind$namedEnum$();
  }
  return $n_Lapp_data_AppDocumentKind$namedEnum$;
}
export { $m_Lapp_data_AppDocumentKind$namedEnum$ as $m_Lapp_data_AppDocumentKind$namedEnum$ };
function $p_Lapp_data_AppDocumentKind$__order__Lapp_data_AppDocumentKind__I($thiz, kind) {
  var x = $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind();
  if ((x === kind)) {
    return 0;
  }
  var x$3 = $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind();
  if ((x$3 === kind)) {
    return 1;
  }
  var x$5 = $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind();
  if ((x$5 === kind)) {
    return 2;
  }
  var x$7 = $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind();
  if ((x$7 === kind)) {
    return 3;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(kind);
}
export { $p_Lapp_data_AppDocumentKind$__order__Lapp_data_AppDocumentKind__I as $p_Lapp_data_AppDocumentKind$__order__Lapp_data_AppDocumentKind__I };
function $s_Lapp_data_AppDocumentKind$__app$data$AppDocumentKind$$anon$2$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_data_AppDocumentKind$__app$data$AppDocumentKind$$anon$2$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_data_AppDocumentKind$__app$data$AppDocumentKind$$anon$2$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_data_AppDocumentKind$__app$data$AppDocumentKind$$anon$2$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind() {
  $m_Lapp_data_AppDocumentKind$();
  return $t_Lapp_data_AppDocumentKind$__PurchaseOrder;
}
export { $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind as $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind };
function $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind() {
  $m_Lapp_data_AppDocumentKind$();
  return $t_Lapp_data_AppDocumentKind$__Invoice;
}
export { $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind as $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind };
function $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind() {
  $m_Lapp_data_AppDocumentKind$();
  return $t_Lapp_data_AppDocumentKind$__CertificateOfOrigin;
}
export { $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind as $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind };
function $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind() {
  $m_Lapp_data_AppDocumentKind$();
  return $t_Lapp_data_AppDocumentKind$__CreditNote;
}
export { $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind as $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind };
/** @constructor */
function $c_Lapp_data_AppDocumentKind$() {
  this.aza = null;
  this.azh = null;
  this.azi = false;
  this.azl = null;
  this.azm = false;
  this.azj = null;
  this.azk = false;
  this.azf = null;
  this.azg = false;
  this.azd = null;
  this.aze = false;
  this.azb = null;
  this.azc = false;
  $n_Lapp_data_AppDocumentKind$ = this;
  $t_Lapp_data_AppDocumentKind$__PurchaseOrder = new $c_Lapp_data_AppDocumentKind$$anon$1("PurchaseOrder", 0);
  $t_Lapp_data_AppDocumentKind$__Invoice = new $c_Lapp_data_AppDocumentKind$$anon$1("Invoice", 1);
  $t_Lapp_data_AppDocumentKind$__CertificateOfOrigin = new $c_Lapp_data_AppDocumentKind$$anon$1("CertificateOfOrigin", 2);
  $t_Lapp_data_AppDocumentKind$__CreditNote = new $c_Lapp_data_AppDocumentKind$$anon$1("CreditNote", 3);
  this.aza = new ($d_Lapp_data_AppDocumentKind.r().C)([$s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind(), $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind(), $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind(), $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind()]);
}
export { $c_Lapp_data_AppDocumentKind$ as $c_Lapp_data_AppDocumentKind$ };
$p = $c_Lapp_data_AppDocumentKind$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentKind$;
/** @constructor */
function $h_Lapp_data_AppDocumentKind$() {
}
export { $h_Lapp_data_AppDocumentKind$ as $h_Lapp_data_AppDocumentKind$ };
$h_Lapp_data_AppDocumentKind$.prototype = $p;
$p.bx9 = (function() {
  return this.aza.aS();
});
$p.bNk = (function() {
  if ((!this.azi)) {
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((kind) => $p_Lapp_data_AppDocumentKind$__order__Lapp_data_AppDocumentKind__I($m_Lapp_data_AppDocumentKind$(), kind)));
    this.azh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_math_Ordering$$anon$5($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$Int$(), f);
    this.azi = true;
  }
  return this.azh;
});
$p.bMu = (function(s) {
  var this$2 = $m_Lapp_data_AppDocumentKind$namedEnum$().ahv.x(s);
  if (this$2.c()) {
    var this$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$ToShowOps$$anon$3(s, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_instances_package$string$().bi);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(("Invalid AppDocumentKind: " + this$6.bq.aT(this$6.bp)));
  } else {
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right(this$2.g());
  }
});
$p.fI = (function() {
  if ((!this.azm)) {
    this.azl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_Codec__mapEither__F1__F1__Lsttp_tapir_Codec($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Codec$().hY, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((s) => $m_Lapp_data_AppDocumentKind$().bMu(s))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((a) => $m_Lapp_data_AppDocumentKind$namedEnum$().bwE(a))));
    this.azm = true;
  }
  return this.azl;
});
$p.Ec = (function() {
  if ((!this.azk)) {
    this.azj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UrlConvertible$fromCodec(this.fI(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lurldsl_errors_DummyError$().sR());
    this.azk = true;
  }
  return this.azj;
});
$p.aL = (function() {
  if ((!this.azg)) {
    var SchemaMagnoliaDerivation_this = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
    $m_Lapp_data_AppDocumentKind$();
    var derivation = new $c_Lapp_data_AppDocumentKind$$anon$2(SchemaMagnoliaDerivation_this);
    var typeInfo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "AppDocumentKind", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var $x_2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "PurchaseOrder", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var it = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
    var n = it.aw();
    if ((n > (-1))) {
      var elements = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(n);
      var iterator = it.r();
      var i = 0;
      while ((i < n)) {
        elements.a[i] = iterator.k();
        i = ((1 + i) | 0);
      }
      var $x_1 = elements;
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var iterator$2 = it.r();
      while (iterator$2.l()) {
        var elem = iterator$2.k();
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
      }
      var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(jsElems);
    }
    var elements$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$1 = 0;
    while ((i$1 < 0)) {
      elements$1.a[i$1] = iterator$1.k();
      i$1 = ((1 + i$1) | 0);
    }
    var elements$2 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.r().C)(0);
    var iterator$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$2 = 0;
    while ((i$2 < 0)) {
      elements$2.a[i$2] = iterator$3.k();
      i$2 = ((1 + i$2) | 0);
    }
    var sub = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$Subtype($x_2, $x_1, elements$1, elements$2, false, 0, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lmagnolia1_CallByNeed$().A(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var m$proxy2 = $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind();
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array = new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lmagnolia1_CaseClass$Param.r().C)(xs.q());
      var iterator$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$3 = 0;
      while (iterator$4.l()) {
        array.a[i$3] = iterator$4.k();
        i$3 = ((1 + i$3) | 0);
      }
      var $x_3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "PurchaseOrder", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
      var array$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$1.q());
      var iterator$5 = xs$1.r();
      var i$4 = 0;
      while (iterator$5.l()) {
        array$1.a[i$4] = iterator$5.k();
        i$4 = ((1 + i$4) | 0);
      }
      var xs$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$2.q());
      var iterator$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$5 = 0;
      while (iterator$6.l()) {
        array$2.a[i$5] = iterator$6.k();
        i$5 = ((1 + i$5) | 0);
      }
      var xs$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$3.q());
      var iterator$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$6 = 0;
      while (iterator$7.l()) {
        array$3.a[i$6] = iterator$7.k();
        i$6 = ((1 + i$6) | 0);
      }
      return derivation.aq(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_3, false, false, array, array$1, array$2, array$3, m$proxy2));
    }))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x) => ((x === $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind()) && (x !== null)))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$7) => _$7))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var $x_5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "Invoice", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var it$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
    var n$1 = it$3.aw();
    if ((n$1 > (-1))) {
      var elements$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(n$1);
      var iterator$8 = it$3.r();
      var i$7 = 0;
      while ((i$7 < n$1)) {
        elements$3.a[i$7] = iterator$8.k();
        i$7 = ((1 + i$7) | 0);
      }
      var $x_4 = elements$3;
    } else {
      var capacity$1 = 0;
      var size$1 = 0;
      var jsElems$1 = null;
      capacity$1 = 0;
      size$1 = 0;
      jsElems$1 = [];
      var iterator$2$1 = it$3.r();
      while (iterator$2$1.l()) {
        var elem$1 = iterator$2$1.k();
        var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
        jsElems$1.push(unboxedElem$1);
      }
      var $x_4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(jsElems$1);
    }
    var elements$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$8 = 0;
    while ((i$8 < 0)) {
      elements$4.a[i$8] = iterator$9.k();
      i$8 = ((1 + i$8) | 0);
    }
    var elements$5 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.r().C)(0);
    var iterator$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$9 = 0;
    while ((i$9 < 0)) {
      elements$5.a[i$9] = iterator$10.k();
      i$9 = ((1 + i$9) | 0);
    }
    var sub$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$Subtype($x_5, $x_4, elements$4, elements$5, false, 1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lmagnolia1_CallByNeed$().A(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var m$proxy3 = $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind();
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var xs$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$4 = new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lmagnolia1_CaseClass$Param.r().C)(xs$4.q());
      var iterator$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$10 = 0;
      while (iterator$11.l()) {
        array$4.a[i$10] = iterator$11.k();
        i$10 = ((1 + i$10) | 0);
      }
      var $x_6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "Invoice", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var xs$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
      var array$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$5.q());
      var iterator$12 = xs$5.r();
      var i$11 = 0;
      while (iterator$12.l()) {
        array$5.a[i$11] = iterator$12.k();
        i$11 = ((1 + i$11) | 0);
      }
      var xs$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$6.q());
      var iterator$13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$12 = 0;
      while (iterator$13.l()) {
        array$6.a[i$12] = iterator$13.k();
        i$12 = ((1 + i$12) | 0);
      }
      var xs$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$7.q());
      var iterator$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$13 = 0;
      while (iterator$14.l()) {
        array$7.a[i$13] = iterator$14.k();
        i$13 = ((1 + i$13) | 0);
      }
      return derivation.aq(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_6, false, false, array$4, array$5, array$6, array$7, m$proxy3));
    }))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$2) => ((x$2 === $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind()) && (x$2 !== null)))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$7$2) => _$7$2))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var $x_8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "CertificateOfOrigin", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var it$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
    var n$2 = it$6.aw();
    if ((n$2 > (-1))) {
      var elements$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(n$2);
      var iterator$15 = it$6.r();
      var i$14 = 0;
      while ((i$14 < n$2)) {
        elements$6.a[i$14] = iterator$15.k();
        i$14 = ((1 + i$14) | 0);
      }
      var $x_7 = elements$6;
    } else {
      var capacity$2 = 0;
      var size$2 = 0;
      var jsElems$2 = null;
      capacity$2 = 0;
      size$2 = 0;
      jsElems$2 = [];
      var iterator$2$2 = it$6.r();
      while (iterator$2$2.l()) {
        var elem$2 = iterator$2$2.k();
        var unboxedElem$2 = ((elem$2 === null) ? null : elem$2);
        jsElems$2.push(unboxedElem$2);
      }
      var $x_7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(jsElems$2);
    }
    var elements$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$15 = 0;
    while ((i$15 < 0)) {
      elements$7.a[i$15] = iterator$16.k();
      i$15 = ((1 + i$15) | 0);
    }
    var elements$8 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.r().C)(0);
    var iterator$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$16 = 0;
    while ((i$16 < 0)) {
      elements$8.a[i$16] = iterator$17.k();
      i$16 = ((1 + i$16) | 0);
    }
    var sub$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$Subtype($x_8, $x_7, elements$7, elements$8, false, 2, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lmagnolia1_CallByNeed$().A(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var m$proxy4 = $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind();
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var xs$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$8 = new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lmagnolia1_CaseClass$Param.r().C)(xs$8.q());
      var iterator$18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$17 = 0;
      while (iterator$18.l()) {
        array$8.a[i$17] = iterator$18.k();
        i$17 = ((1 + i$17) | 0);
      }
      var $x_9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "CertificateOfOrigin", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var xs$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
      var array$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$9.q());
      var iterator$19 = xs$9.r();
      var i$18 = 0;
      while (iterator$19.l()) {
        array$9.a[i$18] = iterator$19.k();
        i$18 = ((1 + i$18) | 0);
      }
      var xs$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$10.q());
      var iterator$20 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$19 = 0;
      while (iterator$20.l()) {
        array$10.a[i$19] = iterator$20.k();
        i$19 = ((1 + i$19) | 0);
      }
      var xs$11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$11.q());
      var iterator$21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$20 = 0;
      while (iterator$21.l()) {
        array$11.a[i$20] = iterator$21.k();
        i$20 = ((1 + i$20) | 0);
      }
      return derivation.aq(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_9, false, false, array$8, array$9, array$10, array$11, m$proxy4));
    }))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$3) => ((x$3 === $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind()) && (x$3 !== null)))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$7$3) => _$7$3))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var $x_11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "CreditNote", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var it$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
    var n$3 = it$9.aw();
    if ((n$3 > (-1))) {
      var elements$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(n$3);
      var iterator$22 = it$9.r();
      var i$21 = 0;
      while ((i$21 < n$3)) {
        elements$9.a[i$21] = iterator$22.k();
        i$21 = ((1 + i$21) | 0);
      }
      var $x_10 = elements$9;
    } else {
      var capacity$3 = 0;
      var size$3 = 0;
      var jsElems$3 = null;
      capacity$3 = 0;
      size$3 = 0;
      jsElems$3 = [];
      var iterator$2$3 = it$9.r();
      while (iterator$2$3.l()) {
        var elem$3 = iterator$2$3.k();
        var unboxedElem$3 = ((elem$3 === null) ? null : elem$3);
        jsElems$3.push(unboxedElem$3);
      }
      var $x_10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(jsElems$3);
    }
    var elements$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$23 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$22 = 0;
    while ((i$22 < 0)) {
      elements$10.a[i$22] = iterator$23.k();
      i$22 = ((1 + i$22) | 0);
    }
    var elements$11 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.r().C)(0);
    var iterator$24 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$23 = 0;
    while ((i$23 < 0)) {
      elements$11.a[i$23] = iterator$24.k();
      i$23 = ((1 + i$23) | 0);
    }
    var sub$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$Subtype($x_11, $x_10, elements$10, elements$11, false, 3, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lmagnolia1_CallByNeed$().A(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var m$proxy5 = $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind();
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sc_MapFactory$ToFactory($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$()).y($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var xs$12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$12 = new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lmagnolia1_CaseClass$Param.r().C)(xs$12.q());
      var iterator$25 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$24 = 0;
      while (iterator$25.l()) {
        array$12.a[i$24] = iterator$25.k();
        i$24 = ((1 + i$24) | 0);
      }
      var $x_12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_TypeInfo("app.data", "CreditNote", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      var xs$13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
      var array$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$13.q());
      var iterator$26 = xs$13.r();
      var i$25 = 0;
      while (iterator$26.l()) {
        array$13.a[i$25] = iterator$26.k();
        i$25 = ((1 + i$25) | 0);
      }
      var xs$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$14.q());
      var iterator$27 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$26 = 0;
      while (iterator$27.l()) {
        array$14.a[i$26] = iterator$27.k();
        i$26 = ((1 + i$26) | 0);
      }
      var xs$15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var array$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(xs$15.q());
      var iterator$28 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
      var i$27 = 0;
      while (iterator$28.l()) {
        array$15.a[i$27] = iterator$28.k();
        i$27 = ((1 + i$27) | 0);
      }
      return derivation.aq(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_12, false, false, array$12, array$13, array$14, array$15, m$proxy5));
    }))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$4) => ((x$4 === $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind()) && (x$4 !== null)))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$7$4) => _$7$4))), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var this$143 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().fO(sub$4);
    if ((this$143.bs(1) <= 0)) {
      var $x_13 = this$143;
    } else {
      var builder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
      var seen = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_HashSet__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_HashSet());
      var it$12 = this$143.r();
      var different = false;
      while (it$12.l()) {
        var next = it$12.k();
        if (seen.aF(next.ci)) {
          builder.fd(next);
        } else {
          different = true;
        }
      }
      var $x_13 = (different ? builder.a2() : this$143);
    }
    var this$147 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($x_13, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$9) => _$9.ci.W())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$String$()).fO(sub$3);
    if ((this$147.bs(1) <= 0)) {
      var $x_14 = this$147;
    } else {
      var builder$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
      var seen$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_HashSet__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_HashSet());
      var it$13 = this$147.r();
      var different$1 = false;
      while (it$13.l()) {
        var next$1 = it$13.k();
        if (seen$1.aF(next$1.ci)) {
          builder$1.fd(next$1);
        } else {
          different$1 = true;
        }
      }
      var $x_14 = (different$1 ? builder$1.a2() : this$147);
    }
    var this$151 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($x_14, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$9$2) => _$9$2.ci.W())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$String$()).fO(sub$2);
    if ((this$151.bs(1) <= 0)) {
      var $x_15 = this$151;
    } else {
      var builder$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
      var seen$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_HashSet__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_HashSet());
      var it$14 = this$151.r();
      var different$2 = false;
      while (it$14.l()) {
        var next$2 = it$14.k();
        if (seen$2.aF(next$2.ci)) {
          builder$2.fd(next$2);
        } else {
          different$2 = true;
        }
      }
      var $x_15 = (different$2 ? builder$2.a2() : this$151);
    }
    var this$155 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($x_15, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$9$3) => _$9$3.ci.W())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$String$()).fO(sub);
    if ((this$155.bs(1) <= 0)) {
      var $x_16 = this$155;
    } else {
      var builder$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
      var seen$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_HashSet__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_HashSet());
      var it$15 = this$155.r();
      var different$3 = false;
      while (it$15.l()) {
        var next$3 = it$15.k();
        if (seen$3.aF(next$3.ci)) {
          builder$3.fd(next$3);
        } else {
          different$3 = true;
        }
      }
      var $x_16 = (different$3 ? builder$3.a2() : this$155);
    }
    var xs$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($x_16, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$9$4) => _$9$4.ci.W())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$String$());
    var array$16 = new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lmagnolia1_SealedTrait$Subtype.r().C)(xs$16.q());
    var iterator$29 = xs$16.r();
    var i$28 = 0;
    while (iterator$29.l()) {
      array$16.a[i$28] = iterator$29.k();
      i$28 = ((1 + i$28) | 0);
    }
    var it$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().m(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description("Kind of the document")])));
    var n$4 = it$16.aw();
    if ((n$4 > (-1))) {
      var elements$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(n$4);
      var iterator$30 = it$16.r();
      var i$29 = 0;
      while ((i$29 < n$4)) {
        elements$12.a[i$29] = iterator$30.k();
        i$29 = ((1 + i$29) | 0);
      }
      var s$4 = elements$12;
    } else {
      var capacity$4 = 0;
      var size$4 = 0;
      var jsElems$4 = null;
      capacity$4 = 0;
      size$4 = 0;
      jsElems$4 = [];
      var iterator$2$4 = it$16.r();
      while (iterator$2$4.l()) {
        var elem$4 = iterator$2$4.k();
        var unboxedElem$4 = ((elem$4 === null) ? null : elem$4);
        jsElems$4.push(unboxedElem$4);
      }
      var s$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(jsElems$4);
    }
    var xs$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var array$17 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.r().C)(xs$17.q());
    var iterator$31 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$30 = 0;
    while (iterator$31.l()) {
      array$17.a[i$30] = iterator$31.k();
      i$30 = ((1 + i$30) | 0);
    }
    var elements$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$32 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().B;
    var i$31 = 0;
    while ((i$31 < 0)) {
      elements$13.a[i$31] = iterator$32.k();
      i$31 = ((1 + i$31) | 0);
    }
    this.azf = derivation.nm(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait(typeInfo, array$16, s$4, array$17, true, elements$13));
    this.azg = true;
  }
  return this.azf;
});
$p.N = (function() {
  if ((!this.aze)) {
    var evidence$1$proxy1 = $m_Lapp_data_AppDocumentKind$();
    var configuration$proxy1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().bM;
    this.azd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredCodec$__of__T__F0__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_Default__Lio_circe_derivation_ConfiguredCodec($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredCodec$(), "AppDocumentKind", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredDecoder$__of__T__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_Default__Lio_circe_derivation_ConfiguredDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredDecoder$(), "PurchaseOrder", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), configuration$proxy1, $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Default$())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredDecoder$__of__T__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_Default__Lio_circe_derivation_ConfiguredDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredDecoder$(), "Invoice", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), configuration$proxy1, $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Default$())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredDecoder$__of__T__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_Default__Lio_circe_derivation_ConfiguredDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredDecoder$(), "CertificateOfOrigin", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), configuration$proxy1, $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Default$())), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredDecoder$__of__T__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_Default__Lio_circe_derivation_ConfiguredDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredDecoder$(), "CreditNote", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), configuration$proxy1, $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Default$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())))))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredEncoder$__of__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_ConfiguredEncoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredEncoder$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), configuration$proxy1, $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind()), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredEncoder$__of__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_ConfiguredEncoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredEncoder$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), configuration$proxy1, $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind()), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredEncoder$__of__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_ConfiguredEncoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredEncoder$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), configuration$proxy1, $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind()), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lio_circe_derivation_ConfiguredEncoder$__of__F0__sci_List__Lio_circe_derivation_Configuration__s_deriving_Mirror__Lio_circe_derivation_ConfiguredEncoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_ConfiguredEncoder$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), configuration$proxy1, $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind()), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())))))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("PurchaseOrder", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("Invoice", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("CertificateOfOrigin", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("CreditNote", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())))), configuration$proxy1, evidence$1$proxy1, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T4($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Default$()));
    this.aze = true;
  }
  return this.azd;
});
$p.hL = (function() {
  if ((!this.azc)) {
    this.azb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.azc = true;
  }
  return this.azb;
});
$p.dl = (function(x) {
  return x.ahu;
});
var $d_Lapp_data_AppDocumentKind$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentKind$, "app.data.AppDocumentKind$", ({
  C5: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_AppDocumentKind$ as $d_Lapp_data_AppDocumentKind$ };
var $n_Lapp_data_AppDocumentKind$;
function $m_Lapp_data_AppDocumentKind$() {
  if ((!$n_Lapp_data_AppDocumentKind$)) {
    $n_Lapp_data_AppDocumentKind$ = new $c_Lapp_data_AppDocumentKind$();
  }
  return $n_Lapp_data_AppDocumentKind$;
}
export { $m_Lapp_data_AppDocumentKind$ as $m_Lapp_data_AppDocumentKind$ };
function $p_Lapp_data_AppDocumentKind$$anon$2__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct($thiz, ctx) {
  var $x_11 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var $x_10 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$();
  var arr = ctx.a4;
  var f = ((p) => {
    var annotations = $p_Lapp_data_AppDocumentKind$$anon$2__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(p.bP), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(p.bQ));
    var pSchema = $p_Lapp_data_AppDocumentKind$$anon$2__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, p.an(), annotations);
    var this$2 = annotations.ap(new $j_app$002edata$002e$002dApp$002dDocument$002dKind$0024$0024anon$00244.$c_Lapp_data_AppDocumentKind$$anon$4());
    var encodedName = (this$2.c() ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_Configuration$().bk.bI.h(p.at) : this$2.g());
    var this$5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_SchemaType$SProductField$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SProductField$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_FieldName(p.at, encodedName), pSchema, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((p$3) => ((t) => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(p$3.bT(t))))(p)), this$5);
  });
  var len = arr.a.length;
  var ys = new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lsttp_tapir_SchemaType$SProductField.r().C)(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var arg1 = arr.a[i];
        ys.a[$x_1] = f(arg1);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var arg1$1 = arr.a[i];
        ys.a[$x_2] = f(arg1$1);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var arg1$2 = arr.a[i];
        ys.a[$x_3] = f(arg1$2);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t$1 = arr.a[i];
        var lo = t$1.i;
        var hi = t$1.j;
        ys.a[$x_4] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var arg1$3 = arr.a[i];
        ys.a[$x_5] = f(arg1$3);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var arg1$4 = arr.a[i];
        ys.a[$x_6] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(arg1$4));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var arg1$5 = arr.a[i];
        ys.a[$x_7] = f(arg1$5);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var arg1$6 = arr.a[i];
        ys.a[$x_8] = f(arg1$6);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var arg1$7 = arr.a[i];
        ys.a[$x_9] = f(arg1$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arr);
    }
  }
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SProduct($x_11.T($x_10.ba(ys)));
}
export { $p_Lapp_data_AppDocumentKind$$anon$2__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct as $p_Lapp_data_AppDocumentKind$$anon$2__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct };
function $p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, typeName, annotations) {
  var x14 = annotations.ap(new $j_app$002edata$002e$002dApp$002dDocument$002dKind$0024$0024anon$00243.$c_Lapp_data_AppDocumentKind$$anon$3());
  if ((x14 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var altName = x14.a7;
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$SName$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$SName(altName, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
  }
  if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() === x14)) {
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$SName$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$SName(typeName.W(), $s_Lapp_data_AppDocumentKind$__app$data$AppDocumentKind$$anon$2$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(typeName).aa(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$1) => _$1.W()))).a2());
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x14);
}
export { $p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName as $p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName };
function $p_Lapp_data_AppDocumentKind$$anon$2__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName($thiz, subtype) {
  return $p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, subtype.ci, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(subtype.lu));
}
export { $p_Lapp_data_AppDocumentKind$$anon$2__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName as $p_Lapp_data_AppDocumentKind$$anon$2__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName };
function $p_Lapp_data_AppDocumentKind$$anon$2__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, schema, annotations) {
  return annotations.aU(schema, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction2(((x$1, x$2) => {
    if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$annotations$description)) {
      return x$1.bw(x$2.bR);
    } else if (false) {
      return x$1.bJ(x$2.c2());
    } else if (false) {
      return x$1.bS(x$2.c0(), x$2.c1());
    } else if (false) {
      return x$1.au(x$2.av());
    } else if (false) {
      var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$().bH]));
      var modify = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((ann$6) => ((_$2) => _$2.au(ann$6.av())))(x$2));
      return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T(fields), modify);
    } else {
      return (false ? x$1.bC(x$2.c3()) : (false ? x$1.bZ(x$2.Z()) : (false ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(x$1.ag, x$1.bg, x$1.bc, x$1.be, x$1.bb, x$1.aj, x$1.bf, true, x$1.b7, x$1.b8, x$1.b6) : (false ? x$2.bU().h(x$1) : x$1))));
    }
  })));
}
export { $p_Lapp_data_AppDocumentKind$$anon$2__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema as $p_Lapp_data_AppDocumentKind$$anon$2__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema };
function $p_Lapp_data_AppDocumentKind$$anon$2__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, primary, inherited) {
  return primary.b1(inherited.bL().aM(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => (!primary.aX(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$3) => ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(_$3) === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(x$1))))))))));
}
export { $p_Lapp_data_AppDocumentKind$$anon$2__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq as $p_Lapp_data_AppDocumentKind$$anon$2__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq };
/** @constructor */
function $c_Lapp_data_AppDocumentKind$$anon$2(SchemaMagnoliaDerivation_this$2) {
  this.byy = null;
  this.byy = SchemaMagnoliaDerivation_this$2;
}
export { $c_Lapp_data_AppDocumentKind$$anon$2 as $c_Lapp_data_AppDocumentKind$$anon$2 };
$p = $c_Lapp_data_AppDocumentKind$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentKind$$anon$2;
/** @constructor */
function $h_Lapp_data_AppDocumentKind$$anon$2() {
}
export { $h_Lapp_data_AppDocumentKind$$anon$2 as $h_Lapp_data_AppDocumentKind$$anon$2 };
$h_Lapp_data_AppDocumentKind$$anon$2.prototype = $p;
$p.aq = (function(ctx) {
  var typeName = ctx.a5;
  var annotations = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(ctx.a6);
  var cacheKey = typeName.W();
  var inProgress = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().X.g();
  var newCache = (inProgress === null);
  if (newCache) {
    inProgress = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Set$().aN($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.r().C)([])));
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().X.bn(inProgress);
  }
  if (inProgress.ai(cacheKey)) {
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SRef($p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations)), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Validator$().R), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_AttributeMap$().Q));
  } else {
    try {
      inProgress.aF(cacheKey);
      if (ctx.bO) {
        if ((!$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().bY(ctx.a4))) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "Cannot derive schema for generic value class: ") + ctx.a5.bF));
        }
        var valueSchema = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().bX(ctx.a4).an();
        var schemaType$1 = valueSchema.ag;
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var name$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var isOptional$1 = false;
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var default$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var encodedExample$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var deprecated$1 = false;
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var hidden$1 = false;
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var validator$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Validator$().R;
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var attributes$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_AttributeMap$().Q;
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(schemaType$1, name$1$1, isOptional$1, description$1, default$1$1, valueSchema.aj, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
      } else {
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
        var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema($p_Lapp_data_AppDocumentKind$$anon$2__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct(this, ctx), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.a5, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(ctx.a6))), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Validator$().R), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_AttributeMap$().Q));
      }
      return $p_Lapp_data_AppDocumentKind$$anon$2__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema(this, $x_1, $p_Lapp_data_AppDocumentKind$$anon$2__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq(this, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(ctx.a6), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(ctx.bN)));
    } finally {
      inProgress.bd(cacheKey);
      if (newCache) {
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().X.bm();
      }
    }
  }
});
$p.nm = (function(ctx) {
  var typeName = ctx.g4;
  var annotations = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(ctx.jC);
  var cacheKey = typeName.W();
  var inProgress = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().X.g();
  var newCache = (inProgress === null);
  if (newCache) {
    inProgress = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Set$().aN($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.r().C)([])));
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().X.bn(inProgress);
  }
  if (inProgress.ai(cacheKey)) {
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SRef($p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations)), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Validator$().R), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_AttributeMap$().Q));
  } else {
    try {
      inProgress.aF(cacheKey);
      var this$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().ba(ctx.eQ));
      var f = ((s) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, s.ci, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(s.lu)), s.an()));
      if ((this$17 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var arg1 = this$17.H();
        var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(arg1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t = h;
        var rest = this$17.K();
        while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var arg1$1 = rest.H();
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(arg1$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t.ac = nx;
          t = nx;
          rest = rest.K();
        }
        var $x_1 = h;
      }
      var subtypesByName = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_internal_package$IterableToListMap($x_1).wu($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$().w);
      var baseCoproduct = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SCoproduct($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().T(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$1(subtypesByName)), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((t$1) => {
        var ix$tailLocal1 = 0;
        while (true) {
          if ((ix$tailLocal1 >= ctx.eQ.a.length)) {
            throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (((("The given value `" + t$1) + "` is not a sub type of `") + ctx.g4) + "`"));
          }
          var arr$1 = ctx.eQ;
          var n = ix$tailLocal1;
          var sub = arr$1.a[n];
          if ((!sub.a9(t$1))) {
            ix$tailLocal1 = ((1 + ix$tailLocal1) | 0);
            continue;
          }
          var arg1$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$SubtypeValue(sub, t$1);
          var this$24 = subtypesByName.x($p_Lapp_data_AppDocumentKind$$anon$2__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName(this, arg1$2.tL));
          return (this$24.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SchemaWithValue(this$24.g(), arg1$2.eP())));
        }
      })));
      matchResult16: {
        var coproduct;
        var x51 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_Configuration$().bk.rl;
        if ((x51 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var d = x51.a7;
          var $x_12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
          var $x_11 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$();
          var arr$2 = ctx.eQ;
          var f$1 = ((s$2) => {
            var schemaName = $p_Lapp_data_AppDocumentKind$$anon$2__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName(this, s$2);
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_Configuration$().bk.rm.h(schemaName), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SRef(schemaName));
          });
          var len = arr$2.a.length;
          var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.r().C)(len);
          if ((len > 0)) {
            var i = 0;
            if ((arr$2 !== null)) {
              while ((i < len)) {
                var $x_2 = i;
                var arg1$4 = arr$2.a[i];
                ys.a[$x_2] = f$1(arg1$4);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
              while ((i < len)) {
                var $x_3 = i;
                var arg1$5 = arr$2.a[i];
                ys.a[$x_3] = f$1(arg1$5);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
              while ((i < len)) {
                var $x_4 = i;
                var arg1$6 = arr$2.a[i];
                ys.a[$x_4] = f$1(arg1$6);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
              while ((i < len)) {
                var $x_5 = i;
                var t$2 = arr$2.a[i];
                var lo = t$2.i;
                var hi = t$2.j;
                ys.a[$x_5] = f$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
              while ((i < len)) {
                var $x_6 = i;
                var arg1$7 = arr$2.a[i];
                ys.a[$x_6] = f$1(arg1$7);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
              while ((i < len)) {
                var $x_7 = i;
                var arg1$8 = arr$2.a[i];
                ys.a[$x_7] = f$1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(arg1$8));
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
              while ((i < len)) {
                var $x_8 = i;
                var arg1$9 = arr$2.a[i];
                ys.a[$x_8] = f$1(arg1$9);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
              while ((i < len)) {
                var $x_9 = i;
                var arg1$10 = arr$2.a[i];
                ys.a[$x_9] = f$1(arg1$10);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
              while ((i < len)) {
                var $x_10 = i;
                var arg1$11 = arr$2.a[i];
                ys.a[$x_10] = f$1(arg1$11);
                i = ((1 + i) | 0);
              }
            } else {
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arr$2);
            }
          }
          var discriminatorMapping = $x_12.cr($x_11.ba(ys));
          var coproduct = baseCoproduct.y1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_FieldName(d, d), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SString(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Validator$().R), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_AttributeMap$().Q))), discriminatorMapping);
          break matchResult16;
        }
        if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() === x51)) {
          var coproduct = baseCoproduct;
          break matchResult16;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x51);
      }
      $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(coproduct, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($p_Lapp_data_AppDocumentKind$$anon$2__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.g4, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_IArray$package$IArray$().m(ctx.jC))), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Validator$().R), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_AttributeMap$().Q));
    } finally {
      inProgress.bd(cacheKey);
      if (newCache) {
        $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().X.bm();
      }
    }
  }
});
var $d_Lapp_data_AppDocumentKind$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentKind$$anon$2, "app.data.AppDocumentKind$$anon$2", ({
  C7: 1,
  t: 1,
  v: 1,
  u: 1
}));
export { $d_Lapp_data_AppDocumentKind$$anon$2 as $d_Lapp_data_AppDocumentKind$$anon$2 };
/** @constructor */
function $c_Lapp_data_AppDocumentKind() {
}
export { $c_Lapp_data_AppDocumentKind as $c_Lapp_data_AppDocumentKind };
$p = $c_Lapp_data_AppDocumentKind.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentKind;
/** @constructor */
function $h_Lapp_data_AppDocumentKind() {
}
export { $h_Lapp_data_AppDocumentKind as $h_Lapp_data_AppDocumentKind };
$h_Lapp_data_AppDocumentKind.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.hJ = (function(locale) {
  var x = $s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind();
  if (((x !== null) && (x === this))) {
    var x$3 = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if ((x$3 === locale)) {
      return "Purchase Order";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(locale);
  }
  var x$5 = $s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind();
  if (((x$5 !== null) && (x$5 === this))) {
    var x$7 = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if ((x$7 === locale)) {
      return "Invoice";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(locale);
  }
  var x$9 = $s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind();
  if (((x$9 !== null) && (x$9 === this))) {
    var x$11 = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if ((x$11 === locale)) {
      return "Certificate of Origin";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(locale);
  }
  var x$13 = $s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind();
  if (((x$13 !== null) && (x$13 === this))) {
    var x$15 = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if ((x$15 === locale)) {
      return "Credit Note";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(locale);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
function $isArrayOf_Lapp_data_AppDocumentKind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fP)));
}
export { $isArrayOf_Lapp_data_AppDocumentKind as $isArrayOf_Lapp_data_AppDocumentKind };
var $d_Lapp_data_AppDocumentKind = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "app.data.AppDocumentKind", ({
  fP: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentKind as $d_Lapp_data_AppDocumentKind };
/** @constructor */
function $c_Lapp_data_AppDocumentKind$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.aht = null;
  this.ahu = 0;
  this.aht = \u03b4name$2;
  this.ahu = _$ordinal$2;
}
export { $c_Lapp_data_AppDocumentKind$$anon$1 as $c_Lapp_data_AppDocumentKind$$anon$1 };
$p = $c_Lapp_data_AppDocumentKind$$anon$1.prototype = new $h_Lapp_data_AppDocumentKind();
$p.constructor = $c_Lapp_data_AppDocumentKind$$anon$1;
/** @constructor */
function $h_Lapp_data_AppDocumentKind$$anon$1() {
}
export { $h_Lapp_data_AppDocumentKind$$anon$1 as $h_Lapp_data_AppDocumentKind$$anon$1 };
$h_Lapp_data_AppDocumentKind$$anon$1.prototype = $p;
$p.s = (function() {
  return 0;
});
$p.e = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.u = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.t = (function() {
  return this.aht;
});
$p.n = (function() {
  return this.aht;
});
$p.co = (function() {
  return this.ahu;
});
$p.U = (function(p) {
  return this;
});
var $d_Lapp_data_AppDocumentKind$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentKind$$anon$1, "app.data.AppDocumentKind$$anon$1", ({
  C6: 1,
  fP: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  r: 1,
  d: 1,
  e: 1,
  k: 1
}));
export { $d_Lapp_data_AppDocumentKind$$anon$1 as $d_Lapp_data_AppDocumentKind$$anon$1 };
var $t_Lapp_data_AppDocumentKind$__PurchaseOrder = null;
function $u_Lapp_data_AppDocumentKind$__PurchaseOrder(x) {
  $t_Lapp_data_AppDocumentKind$__PurchaseOrder = x;
}
export { $t_Lapp_data_AppDocumentKind$__PurchaseOrder as $t_Lapp_data_AppDocumentKind$__PurchaseOrder, $u_Lapp_data_AppDocumentKind$__PurchaseOrder as $u_Lapp_data_AppDocumentKind$__PurchaseOrder };
var $t_Lapp_data_AppDocumentKind$__Invoice = null;
function $u_Lapp_data_AppDocumentKind$__Invoice(x) {
  $t_Lapp_data_AppDocumentKind$__Invoice = x;
}
export { $t_Lapp_data_AppDocumentKind$__Invoice as $t_Lapp_data_AppDocumentKind$__Invoice, $u_Lapp_data_AppDocumentKind$__Invoice as $u_Lapp_data_AppDocumentKind$__Invoice };
var $t_Lapp_data_AppDocumentKind$__CertificateOfOrigin = null;
function $u_Lapp_data_AppDocumentKind$__CertificateOfOrigin(x) {
  $t_Lapp_data_AppDocumentKind$__CertificateOfOrigin = x;
}
export { $t_Lapp_data_AppDocumentKind$__CertificateOfOrigin as $t_Lapp_data_AppDocumentKind$__CertificateOfOrigin, $u_Lapp_data_AppDocumentKind$__CertificateOfOrigin as $u_Lapp_data_AppDocumentKind$__CertificateOfOrigin };
var $t_Lapp_data_AppDocumentKind$__CreditNote = null;
function $u_Lapp_data_AppDocumentKind$__CreditNote(x) {
  $t_Lapp_data_AppDocumentKind$__CreditNote = x;
}
export { $t_Lapp_data_AppDocumentKind$__CreditNote as $t_Lapp_data_AppDocumentKind$__CreditNote, $u_Lapp_data_AppDocumentKind$__CreditNote as $u_Lapp_data_AppDocumentKind$__CreditNote };
//# sourceMappingURL=app.data.-App-Document-Kind.js.map
